import { ActionContext, ActionTree } from "vuex";

import { State } from "@/store/types";

export const actions: ActionTree<State, State> = {
};
